import { render, staticRenderFns } from "./kanbanSearch.vue?vue&type=template&id=f7645258"
import script from "./kanbanSearch.vue?vue&type=script&lang=js"
export * from "./kanbanSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports